/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon20Regular = forwardRef('TimeClockMoveBackIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.797 3.755a6.499 6.499 0 0 0-7.276 2.75H6a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 1 1 1.5 0v1.583a7.999 7.999 0 1 1-.703 8.14.75.75 0 1 1 1.35-.652 6.499 6.499 0 1 0 7.65-9.071Z" }),
        React.createElement("path", { d: "M10.48 6.443a.75.75 0 0 0-1.5 0v3.123a2 2 0 0 0 1.085 1.78l2.693 1.383a.75.75 0 0 0 .685-1.334l-2.692-1.384a.5.5 0 0 1-.272-.445V6.443Z" })));
});
